import { Box, Chip, Typography } from "@mui/material"
import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { Link as RouterLink } from "react-router-dom"

export default function useTableColumnsTicket() {
  const columnsTicket = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "codigo_ticket",
        header: "Codigo",
        size: 160,
      },
      {
        accessorKey: "estado_ticket_data.nombre",
        header: "Estado",
        size: 130,
        Cell: ({ row }) => {
          const estado = row.original.estado_ticket_data;
          if (!estado) return '-';
          return (
            <Chip
              label={estado.nombre}
              size="small"
              sx={{
                backgroundColor: estado.color || '#9E9E9E',
                color: '#fff',
                fontWeight: 600,
                fontSize: '0.75rem',
              }}
            />
          );
        },
      },
      {
        accessorKey: "prioridad_data.nombre",
        header: "Prioridad",
        size: 120,
        Cell: ({ row }) => {
          const prioridad = row.original.prioridad_data;
          if (!prioridad) return '-';
          return (
            <Chip
              label={prioridad.nombre}
              size="small"
              variant="outlined"
              sx={{
                borderColor: prioridad.color || '#9E9E9E',
                color: prioridad.color || '#9E9E9E',
                fontWeight: 600,
              }}
            />
          );
        },
      },
      {
        accessorKey: "tipo_data.nombre",
        header: "Tipo",
        size: 150,
      },
      {
        accessorKey: "cliente_razon_social",
        header: "Cliente",
        size: 200,
        Cell: ({ row }) => {
          // UUIDs canonicos del backend ms-tickets. cliente_id/contrato_id
          // (numericos) quedan como fallback por si el row trae el shape
          // legacy de Django REST.
          const clienteUuid = row.original.cliente
            ?? row.original.cliente_data?.id_cliente
            ?? row.original.cliente_id;
          const contratoUuid = row.original.contrato
            ?? row.original.contrato_data?.id_contrato
            ?? row.original.contrato_id;
          const nombre = row.original.cliente_razon_social;
          const identificacion = row.original.cliente_identificacion;

          if (!clienteUuid || !nombre) {
            return (
              <Box>
                <Typography variant="body2" fontWeight={600}>
                  {nombre || '-'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {identificacion || ''}
                </Typography>
              </Box>
            );
          }

          // Link a nuevo-ticket con el cliente pre-cargado; si tambien hay
          // contrato, se preselecciona ese contrato en el Vision360Panel.
          const qs = new URLSearchParams({ clienteId: String(clienteUuid) });
          if (contratoUuid) qs.set('contratoId', String(contratoUuid));
          const href = `/tickets-soporte-cliente/nuevo-ticket?${qs.toString()}`;

          return (
            <Box
              component={RouterLink}
              to={href}
              onClick={(e: React.MouseEvent) => e.stopPropagation()}
              sx={{
                display: 'block',
                textDecoration: 'none',
                color: 'inherit',
                cursor: 'pointer',
                '&:hover .cliente-nombre': {
                  textDecoration: 'underline',
                  color: 'primary.main',
                },
              }}
            >
              <Typography
                variant="body2"
                fontWeight={600}
                className="cliente-nombre"
                sx={{ color: 'primary.main' }}
              >
                {nombre}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {identificacion || ''}
              </Typography>
            </Box>
          );
        },
      },
      {
        accessorKey: "area_origen_data.nombre",
        header: "Area Origen",
        size: 140,
      },
      {
        accessorKey: "area_destino_data.nombre",
        header: "Area Destino",
        size: 140,
      },
      {
        accessorKey: "canal_data.nombre",
        header: "Canal",
        size: 130,
      },
      {
        accessorKey: "usuario_creador_nombre",
        header: "Creado por",
        size: 150,
      },
      {
        accessorKey: "usuario_asignado_nombre",
        header: "Asignado a",
        size: 150,
        Cell: ({ row }) => row.original.usuario_asignado_nombre || '-',
      },
      {
        accessorKey: "descripcion",
        header: "Descripcion",
        size: 250,
        Cell: ({ row }) => (
          <Typography
            variant="body2"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: 250,
            }}
          >
            {row.original.descripcion || '-'}
          </Typography>
        ),
      },
      {
        accessorKey: "fecha_creacion",
        header: "Fecha Creacion",
        size: 160,
        Cell: ({ row }) => {
          const fecha = row.original.fecha_creacion;
          if (!fecha) return '-';
          return new Date(fecha).toLocaleString('es-EC', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          });
        },
      },
    ], []
  )

  const columnsRegistrarAtencion = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: 'canal_comunicaicon',
        header: 'Canal de comunicacion'
      },
      {
        accessorKey: 'observacion',
        header: 'Observacion'
      },
      {
        accessorKey: 'user',
        header: 'usuario creacion'
      },
      {
        accessorKey: 'fecha_registro',
        header: 'Fecha atencion'
      }

    ], []
  )
  return {
    columnsTicket,
    columnsRegistrarAtencion
  }
}
